import { Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

type CardItem = {
  path: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  disabled?: boolean;
};

type CustomCardProps = {
  item: CardItem;
};

const MenuCard: React.FC<CustomCardProps> = ({ item }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!item.disabled) {
      navigate(item.path);
    }
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        width: 200,
        height: 250,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: item.disabled ? "not-allowed" : "pointer",
        opacity: item.disabled ? 0.5 : 1,
        transition: "transform 0.2s",
        "&:hover": {
          transform: item.disabled ? "none" : "scale(1.05)",
        },
      }}
    >
      <CardContent>
        {item.icon}
        <Typography variant="h6" component="div" mt={2}>
          {item.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          {item.description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default MenuCard;
